import { Header, Stack, StackItem } from '@asgard/ui-library';
import {
  /* faArrowRight, */ faDownload
} from '@fortawesome/pro-solid-svg-icons';
import { PageContentContainer } from 'components/layout/Page.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import { HeroStyles as S } from './Hero.styled';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { useRouter } from 'next/router';

export const Hero: React.FC = () => {
  const { t } = useI18n('freelance-talent');
  const { locale } = useRouter();

  return (
    <S.Root>
      <PageContentContainer containerSize="xlMax">
        <S.OuterWrapper>
          <S.Content>
            <StackItem>
              <img
                src={getPublicPath('/images/freelance-talent/hero-image.png')}
                alt="Freelance talent hero image"
              />
            </StackItem>

            <StackItem>
              <Stack direction="column">
                <StackItem>
                  <Header editorial as="h1" size="5xl">
                    {t('freelance-talent.hero.title')}
                  </Header>
                  <HtmlTrans
                    ns="freelance-talent"
                    i18nKey={'freelance-talent.hero.subtitle'}
                  />
                </StackItem>

                <S.CTAs>
                  {/* <S.StyledButtonLink
                    href={getAppUrl(APP_URLS.jobOffers, locale)}
                    schema="brand1"
                    variant="hard"
                    label={t('freelance-talent.hero.cta1')}
                    startIcon={faArrowRight}
                    aria-disabled={true}
                  /> */}

                  {/* <S.TemporalDisabledButton
                    schema="brand1"
                    variant="hard"
                    label={t('freelance-talent.hero.cta1')}
                    startIcon={faArrowRight}
                    disabled
                  /> */}

                  <S.StyledButtonLink
                    href={`${getAppUrl(APP_URLS.blog, locale)}${
                      locale === 'en'
                        ? '/guide-for-freelance-newbies-in-tech'
                        : '/guia-para-freelance-novatos-en-tech-manfred'
                    }`}
                    schema="brand1"
                    variant="ghost"
                    label={t('freelance-talent.hero.cta2')}
                    startIcon={faDownload}
                  />
                </S.CTAs>
              </Stack>
            </StackItem>
          </S.Content>
        </S.OuterWrapper>
      </PageContentContainer>
    </S.Root>
  );
};
